import React from 'react';
import Swal from 'sweetalert2';
import { File } from '../../../../components/IconsSVG';
import AdminDropdown from '../../../../partials/content/CustomDropdowns/AdminDropdown';
import CrudActions from '../../../../partials/datatable/CrudActions';
import Datatable from '../../../../partials/datatable/Datatable';
import { StyledTableCell, StyledTableRow } from '../../../../partials/datatable/styles';
import { MutantApiService } from '../../../../services/MutantApiService';
import store from '../../../../store/store';
import Loading from '../../../home/components/Loading';
import { format } from 'date-fns';

const initialState = {
	providers: [],
	reload: false,
	loading: true,
};

export default class ProvidersListing extends React.Component {
	constructor(props) {
		super(props);
		const { auth } = store.getState();

		this.api = new MutantApiService();

		this.state = {
			...initialState,
			userLogged: auth.user,
		};

		this.handleConfirmChangeStatus = this.handleConfirmChangeStatus.bind(this);
		this.formatRow = this.formatRow.bind(this);
		this.setProviders = this.setProviders.bind(this);
		this.handleConfirmDelete = this.handleConfirmDelete.bind(this);
		this.handleToggleDefault = this.handleToggleDefault.bind(this);
	}

	componentDidMount() {
		this.setState({ loading: false });
	}

	handleConfirmChangeStatus = async function (obj) {
		try {
			await this.setState({ loading: true });

			await this.api.makeHttpRequest({
				method: 'PUT',
				url: `/provider/${obj.id}`,
			});

			await this.setState({ loading: false });

			await Swal.fire({
				title: 'Sucesso!',
				text: 'Status alterado com sucesso.',
				icon: 'success',
				cancelButtonText: 'Sair',
			});
		} catch (e) {
			await this.setState({ loading: false });
			await Swal.fire('Erro!', 'Erro ao alterar status.', 'error');
		} finally {
			await this.setState({ reload: !this.state.reload });
		}
	};

	setProviders = (providers) => {
		this.setState({ providers });
	};

	handleConfirmDelete = async (id) => {
		try {
			const reqBase = { method: "DELETE", url: `/provider/${id}/` }

			await this.api.makeHttpRequest(reqBase);
			await this.setState({ reload: !this.state.reload });
		} catch (e) {
			await Swal.fire(
				"Erro",
				"Problema ao deletar o provedor, tente mais tarde",
				"error"
			);
		}
	}

	handleToggleDefault = async (provider) => {
		try {
			await this.setState({ loading: true });

			await this.api.makeHttpRequest({
				method: 'PUT',
				url: `/provider/${provider.id}/default`,
				data: { default: !provider.default }
			});

			await this.setState({ loading: false });

			await Swal.fire({
				title: 'Sucesso!',
				text: 'Provedor padrão alterado com sucesso.',
				icon: 'success',
				cancelButtonText: 'Sair',
			});
		} catch (e) {
			await this.setState({ loading: false });
			await Swal.fire('Erro!', 'Erro ao alterar provedor padrão.', 'error');
		} finally {
			await this.setState({ reload: !this.state.reload });
		}
	};

	formatRow = (provider) => {
		const crudActions = ['edit', 'delete'];

		return (
			<StyledTableRow hover tabIndex={-1} key={provider.id}>
				<StyledTableCell scope="row" align="left" width="20%">
					{provider.name}
				</StyledTableCell>
				<StyledTableCell scope="row" align="left" width="15%">
					<span style={{ 
						padding: '4px 8px', 
						borderRadius: '4px', 
						fontSize: '12px',
						fontWeight: '500',
						backgroundColor: provider.type === 'INTERNAL' ? '#e3f2fd' : '#f3e5f5',
						color: provider.type === 'INTERNAL' ? '#1976d2' : '#7b1fa2'
					}}>
						{provider.type === 'INTERNAL' ? 'Interno' : 'Externo'}
					</span>
				</StyledTableCell>
				<StyledTableCell scope="row" align="left" width="15%">
					{provider.active ? 'Ativo' : 'Inativo'}
				</StyledTableCell>
				<StyledTableCell scope="row" align="left" width="15%">
					{provider.username || '-'}
				</StyledTableCell>
				<StyledTableCell scope="row" align="center" width="10%">
					<span style={{ 
						padding: '4px 8px', 
						borderRadius: '4px', 
						fontSize: '12px',
						fontWeight: '500',
						backgroundColor: provider.default ? '#e8f5e8' : '#f5f5f5',
						color: provider.default ? '#2e7d32' : '#666'
					}}>
						{provider.default ? 'Padrão' : 'Não'}
					</span>
				</StyledTableCell>
				<StyledTableCell scope="row" align="left" width="15%">
					{!!provider.createdAt && format(new Date(provider.createdAt), 'dd/MM/yyyy')}
				</StyledTableCell>
				<StyledTableCell scope="row" width="10%" align="center">
					<CrudActions
						actions={crudActions}
						module="providers"
						id={provider.id}
						onConfirmChangeStatus={this.handleConfirmChangeStatus}
						onConfirmDelete={this.handleConfirmDelete}
						obj={provider}
					/>
				</StyledTableCell>
			</StyledTableRow>
		);
	};

	render() {
		window.setPageTitle('Gerenciamento de Provedores');

		const headRows = [
			{ label: 'NOME', align: "left" },
			{ label: 'TIPO', align: "left" },
			{ label: 'Ativo', align: "left" },
			{ label: 'USUÁRIO', align: "left" },
			{ label: 'PADRÃO', align: "center" },
			{ label: 'CRIADO EM', align: "left" },
			{ label: 'AÇÕES', align: 'center' },
		];

		return (
			<>
				<Loading isLoading={this.state.loading} />
				<Datatable
					title="Provedores de TTS"
					icon={File}
					endpoint="provider"
					className="h-100"
					headRows={headRows}
					formatRow={this.formatRow}
					rows={this.state.providers}
					setRows={this.setProviders}
					reload={this.state.reload}
					placeholderSearch="Filtre por nome"
					mobile={AdminDropdown}
					width={this.props.width}
					hiddenReload
				/>
			</>
		);
	}
}
